import { createRouter, createWebHistory } from '@ionic/vue-router'
import Tabs from '../views/Tabs.vue'
import HomeView from '../views/home/home.vue'
import AppContent from '../layout/AppContent.vue'
import Blank from '../layout/Blank.vue'
import store from '@/store'
import { emitter } from '@/plugins/events/emitter'
import _ from 'lodash'
import { trackRouter } from 'vue-gtag-next'

const routes = [
  {
    path: '/',
    name: 'root',
    component: AppContent,
    redirect: { name: 'home' },
    meta: { requiresAuth: false },
    children: [
      {
        path: ':pathMatch(.*)*',
        component: () => import('@/views/error/404.vue')
      },
      {
        path: '',
        name: 'home',
        meta: { requiresAuth: false },
        component: HomeView
      },
      {
        path: ':motobrand/:motomodel/:motomodel_id',
        name: 'product-list',
        meta: { requiresAuth: false },
        component: () => import('@/views/product/product_list.vue')
      },
      {
        path: 'app/product/images',
        name: 'product-image-list',
        meta: { requiresAuth: false, hideAppBar: true },
        component: () => import('@/views/product/product_view_image_list.vue')
      },
      {
        path: ':motobrand/:motomodel/:motomodel_id/:product_id',
        name: 'product-detail',
        meta: { requiresAuth: false },
        component: () => import('@/views/product/product_detail.vue')
      },
      {
        path: 'buscar',
        name: 'search',
        meta: { requiresAuth: false },
        component: () => import('@/views/search/search_page.vue')
      },
      {
        path: 'app/tool/view-image',
        name: 'view-image',
        meta: { requiresAuth: false, hideAppBar: true },
        component: () => import('@/components/media/view_image_component.vue')
      },
      {
        path: 'app/tool/contact-form',
        name: 'contact-form',
        meta: { requiresAuth: false },
        component: () =>
          import('@/components/contact/contact_form_component.vue')
      },
      {
        path: 'app/common/messageme',
        name: 'messageme',
        meta: { requiresAuth: false, hideAppBar: true },
        component: () => import('@/views/common/message_me.vue')
      },
      {
        path: 'nosotros',
        name: 'about',
        meta: { requiresAuth: false },
        component: () => import('@/views/corp/about.vue')
      },
      {
        path: 'contactenos',
        name: 'contact',
        meta: { requiresAuth: false },
        component: () => import('@/views/contact/contact_page.vue')
      },
      {
        path: 'carro-compras',
        name: 'cart',
        meta: { requiresAuth: false },
        component: () => import('@/views/cart/cart_page.vue')
      }
    ]
  },
  /* {
    path: '/home',
    name: 'homeOld',
    redirect: { name: 'store' },
    meta: { requiresAuth: false },
    component: AppContent,
    children: [
      {
        path: 'store',
        name: 'store1',
        meta: { requiresAuth: false },
        component: HomeView
      },
      {
        path: 'tabs/',
        name: 'tabs',
        component: Tabs,
        meta: { requiresAuth: false },
        redirect: { name: 'tab1' },
        children: [
          {
            path: 'tab1',
            name: 'tab1',
            meta: { requiresAuth: false },
            component: () => import('@/views/Tab1.vue')
          },
          {
            path: 'tab2',
            name: 'tab2',
            meta: { requiresAuth: false },
            component: () => import('@/views/Tab2.vue')
          },
          {
            path: 'tab3',
            name: 'tab3',
            meta: { requiresAuth: false },
            component: () => import('@/views/Tab3.vue')
          }
        ]
      }
    ]
  }, */
  {
    path: '/login',
    name: 'login',
    meta: { requiresAuth: false },
    component: () => import('@/views/auth/login.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
trackRouter(router, {
  template(to, from) {
    return {
      page_title: to.path,
      page_path: to.path
    }
  }
})

export default router
